<template>
  <div id="MessageCard">
    <div class="card p-2" :class="{ lido: messageData.read }">
      <div class="row" @click="toggleMessageCard">
        <div class="col">
          <p class="m-0">
            <strong>Origem:</strong> {{ messageData.source }}
            <span class="small-text" v-if="messageData.created_at"
              >- {{ normalizeDate }}
            </span>
          </p>
        </div>
        <div class="col-auto text-right chev-rotate">
          <i
            class="fas fa-chevron-down"
            :class="{ 'fa-rotate-90': showMore }"
          ></i>
        </div>
      </div>
      <div class="row pt-2" v-if="showMore">
        <div
          class="col-12 message-infos"
          v-for="(item, index) in messageData.contents"
          :key="index"
        >
          <label>{{ item.title }}:</label>
          <p v-if="item.item_type == 'email'">
            <a :href="'mailto:' + item.contents">{{ item.contents }}</a>
          </p>
          <textarea
            readonly
            v-else-if="item.item_type == 'textarea'"
            :value="item.contents"
            class="form-control"
            rows="5"
          />
          <p v-else-if="item.item_type != 'file'">{{ item.contents }}</p>
          <p v-else-if="item.item_type == 'file'">
            <a
              v-for="(subitem, subindex) in item.contents"
              :href="baseUrl + subitem.url"
              :key="subindex"
              target="_blank"
            >
              <p>Baixar arquivo {{ subindex + 1 }}</p>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "MessageCard",
  data() {
    return {
      showMore: false,
      baseUrl: process.env.CDN_URL
    };
  },
  props: {
    messageData: {
      type: Object,
      required: true
    }
  },
  computed: {
    normalizeDate() {
      return this.messageData.created_at.substr(0, 10);
    }
  },
  filters: {
    breakLine(value) {
      return value;
    }
  },
  methods: {
    toggleMessageCard() {
      this.showMore = !this.showMore;
      if (this.messageData.read == null) {
        this.updateReadMessage();
      }
    },
    updateReadMessage() {
      let token = this.$session.get("jwt"),
        siteId = localStorage.siteId;
      axios({
        method: "post",
        url:
          process.env.ROOT_API +
          "api/site/" +
          siteId +
          "/submit/" +
          this.messageData.id +
          "/read",
        headers: {
          Authorization: "Bearer " + token
          // 'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => {
          this.messageData.read = response.data.read;
        })
        .catch(response => {
          console.log("Erro atualizar mensagens");
        });
    }
  }
};
</script>

<style scoped>
.card {
  border: 2px solid var(--bg-color);
  transition: all 0.3s;
}
.card.lido {
  border: 1px solid #777;
  transition: all 0.3s;
}
.small-text {
  font-size: 0.7rem;
}
.message-infos textarea:read-only {
  background-color: #fff;
}
.message-infos p,
.message-infos textarea,
.message-infos a {
  margin-bottom: 2px;
  color: #000;
}
.message-infos a:hover {
  text-decoration: none;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/MessageCard.vue